import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface ChangePasswordProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChangePassword = ({ isOpen, onClose }: ChangePasswordProps) => {
  const navigate = useNavigate();

  const onSave = () => {
    navigate('/change-password');
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Change Password"
      confirmButton={{
        name: 'Continue',
        onClick: onSave
      }}
    >
      <ModalDescription color={themeVar('font.base')}>Are you sure you want to change the password associated with your account?</ModalDescription>
      <br />
      <ModalDescription color={themeVar('font.weak')}>
        Upon continuing you will be asked to provide your password, and you will need to sign in again.
      </ModalDescription>
    </ModalWrappedContent>
  );
};

export default ChangePassword;

const ModalDescription = styled.div<{ color: string }>`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: ${({ color }) => color};
`;
